/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import config from '@config';
import MsrSectionTitle from '@msr/components/Headings/MsrSectionTitle';
import SubscribeBox from '@msr/components/UI/Subscribe/SubscribeBox';

/**
 * @returns
 */
const SubscribeForm = ({ sectionContent, lang }) => {
  return (
    <Box
      backgroundColor="#00052F"
      backgroundSize="cover"
      backgroundImage={`${config.imgPath}/d/46272/1665481391-preparatory-sadhana-section-bg.jpg`}
      padding="30px 20px"
      backgroundRepeat="no-repeat"
      mt={{ base: '55px', md: '80px' }}
      sx={{
        h2: {
          fontSize: '26px',
        },
      }}
    >
      <MsrSectionTitle
        titleObj={{
          titleDecoration: 'drums-above',
          title:
            sectionContent?.content?.json?.title || 'Get latest blogs on Shiva',
        }}
      />

      <Box mt="30px">
        <SubscribeBox sectionContent={sectionContent} />
      </Box>
    </Box>
  );
};

export default SubscribeForm;
